import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=dd54dd68&scoped=true"
import script from "./GlobalHeader.vue?vue&type=script&lang=js"
export * from "./GlobalHeader.vue?vue&type=script&lang=js"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&id=dd54dd68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd54dd68",
  null
  
)

export default component.exports